<div class="kbm-acts-page">

  <!-- ── TOP BAR ── -->
  <div class="kbm-topbar">
    <h1>Activities Manager</h1>
    <div style="display:flex;gap:8px">
      <button class="btn-kbm-outline" (click)="openNewProvider()">+ Add Provider</button>
      <button class="btn-kbm-primary" (click)="openNewActivity()">+ New Activity</button>
    </div>
  </div>

  <div class="kbm-body">

    <!-- ── STAT CARDS ── -->
    <div class="kbm-stat-grid">
      <div class="kbm-stat-card">
        <div class="stat-label">Total Activities</div>
        <div class="stat-value">{{totalActivities}}</div>
        <div class="stat-sub">Across all properties</div>
      </div>
      <div class="kbm-stat-card">
        <div class="stat-label">Active</div>
        <div class="stat-value">{{activeCount}}</div>
        <div class="stat-sub">{{draftCount}} in draft</div>
      </div>
      <div class="kbm-stat-card">
        <div class="stat-label">Reservations</div>
        <div class="stat-value">{{reservationCount}}</div>
        <div class="stat-sub">{{unpaidCount}} unpaid</div>
      </div>
      <div class="kbm-stat-card">
        <div class="stat-label">Providers</div>
        <div class="stat-value">{{providers.length}}</div>
        <div class="stat-sub">Activity providers</div>
      </div>
    </div>

    <!-- ── TAB BAR ── -->
    <div class="kbm-tab-bar">
      <button *ngFor="let t of TABS" class="kbm-tab" [class.active]="activeTab === t.id"
        (click)="activeTab = t.id; t.id === 'wishlists' && onWishlistTabActivate()">
        {{t.label}}
      </button>
    </div>

    <!-- ══════════════════════════════════════════════
         TAB: ACTIVITIES
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'activities'">

      <!-- Filter bar -->
      <div class="kbm-filter-bar">
        <div class="filter-row">
          <div class="search-box">
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="#9ca3af" stroke-width="1.5">
              <circle cx="7" cy="7" r="5"/><path d="M11 11l3 3"/>
            </svg>
            <input placeholder="Search activities or providers…" [(ngModel)]="actSearch"/>
          </div>
          <select [(ngModel)]="actFilterCat">
            <option value="">All Categories</option>
            <option *ngFor="let c of CATEGORIES" [value]="c.value">{{c.name}}</option>
          </select>
          <select [(ngModel)]="actFilterProp">
            <option value="">All Properties</option>
            <option *ngFor="let p of PROPERTIES" [value]="p">{{p}}</option>
          </select>
          <select [(ngModel)]="actFilterStatus">
            <option value="">All Statuses</option>
            <option value="active">Active</option>
            <option value="draft">Draft</option>
            <option value="archived">Archived</option>
          </select>
          <button class="clear-btn" (click)="clearActFilters()">Clear</button>
        </div>
      </div>

      <!-- Activities table -->
      <div class="kbm-table-card">
        <div style="overflow-x:auto">
          <table style="width:100%;border-collapse:collapse;font-size:13px;min-width:820px">
            <thead>
              <tr style="background:#111827">
                <th class="th-kbm" style="width:40px"></th>
                <th class="th-kbm">Activity</th>
                <th class="th-kbm">Category</th>
                <th class="th-kbm">Provider</th>
                <th class="th-kbm">Duration</th>
                <th class="th-kbm">Rate</th>
                <th class="th-kbm">Properties</th>
                <th class="th-kbm">Status</th>
                <th class="th-kbm" style="width:80px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="filteredActivities.length === 0">
                <td colspan="9" style="text-align:center;padding:48px 16px;color:#9ca3af">No activities match your filters.</td>
              </tr>
              <tr *ngFor="let a of filteredActivities" class="tr-hover">
                <td class="td-kbm" style="font-size:20px;text-align:center">{{a.emoji}}</td>
                <td class="td-kbm">
                  <div style="font-weight:600;color:#1f2937">{{a.name}}</div>
                  <div style="font-size:11px;color:#9ca3af">{{a.activityType}}</div>
                </td>
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="getCategoryInfo(a.category).cssClass">
                    {{getCategoryInfo(a.category).label}}
                  </span>
                </td>
                <td class="td-kbm" style="color:#6b7280;font-size:12px">{{providerName(a.activityProviderId)}}</td>
                <td class="td-kbm" style="color:#6b7280;font-size:12px;white-space:nowrap">{{a.duration}}</td>
                <td class="td-kbm" style="font-weight:700;color:#1f2937;white-space:nowrap">
                  {{a.rate}}<span style="font-weight:400;color:#9ca3af;font-size:11px">/pp</span>
                </td>
                <td class="td-kbm">
                  <div style="display:flex;flex-wrap:wrap;gap:4px">
                    <ng-container *ngIf="a.properties">
                      <span *ngFor="let p of a.properties?.split(',')?.slice(0,2)" class="prop-chip">{{p?.trim()?.split(' ')[0]}}</span>
                      <span *ngIf="a.properties?.split(',')?.length > 2" class="prop-chip" style="color:#9ca3af">
                        +{{a.properties?.split(',')?.length - 2}}
                      </span>
                    </ng-container>
                  </div>
                </td>
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="'badge-' + a.status">
                    {{a.status | titlecase}}
                  </span>
                </td>
                <td class="td-kbm">
                  <div class="row-actions">
                    <button class="btn-kbm-outline btn-kbm-sm" (click)="openEditActivity(a)">Edit</button>
                    <button class="btn-kbm-outline btn-kbm-sm"
                      (click)="duplicateActivity(a)"
                      [disabled]="duplicatingId !== null"
                      [style.opacity]="duplicatingId !== null ? '0.6' : '1'"
                      [style.cursor]="duplicatingId !== null ? 'not-allowed' : 'pointer'">
                      <ng-container *ngIf="duplicatingId === a.activityId; else dupLabel">
                        <i class="pi pi-spin pi-spinner" style="font-size:11px;margin-right:4px;"></i>
                      </ng-container>
                      <ng-template #dupLabel>Dup</ng-template>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="kbm-table-footer">
          <span>{{filteredActivities.length}} of {{activities.length}} activities shown</span>
          <div class="legend">
            <span><span class="legend-dot" style="background:#10b981"></span>Active</span>
            <span><span class="legend-dot" style="background:#fcd34d"></span>Draft</span>
            <span><span class="legend-dot" style="background:#d1d5db"></span>Archived</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ══════════════════════════════════════════════
         TAB: RESERVATIONS
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'reservations'">
      <app-activity-reservation-list
        [activities]="activities"
        [providers]="providers"
        (showToastEvent)="showToast($event)">
      </app-activity-reservation-list>
    </ng-container>

    <!-- ══════════════════════════════════════════════
         TAB: PROVIDERS
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'providers'">
      <div class="kbm-table-card">
        <div style="overflow-x:auto">
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <thead>
              <tr style="background:#111827">
                <th class="th-kbm">Provider</th>
                <th class="th-kbm">Category</th>
                <th class="th-kbm">Main Contact</th>
                <th class="th-kbm">Phone</th>
                <th class="th-kbm">Email</th>
                <th class="th-kbm">Booking Method</th>
                <th class="th-kbm">Status</th>
                <th class="th-kbm" style="width:60px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="providers.length === 0">
                <td colspan="8" style="text-align:center;padding:48px 16px;color:#9ca3af">No providers found.</td>
              </tr>
              <tr *ngFor="let p of providers" class="tr-hover">
                <td class="td-kbm" style="font-weight:600;color:#1f2937">{{p.name}}</td>
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="getCategoryInfo(p.category).cssClass">
                    {{getCategoryInfo(p.category).label || '—'}}
                  </span>
                </td>
                <td class="td-kbm" style="color:#4b5563">{{p.contactName}}</td>
                <td class="td-kbm" style="font-family:monospace;font-size:12px;color:#4b5563">{{p.phone}}</td>
                <td class="td-kbm" style="font-size:12px;color:#9ca3af">{{p.email}}</td>
                <td class="td-kbm" style="font-size:12px;color:#6b7280">{{p.bookingMethod}}</td>
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="p.status === '0' ? 'badge-active' : 'badge-archived'">
                    {{p.status === '0' ? 'Active' : p.status === '1' ? 'Cancelled' : 'Suspended'}}
                  </span>
                </td>
                <td class="td-kbm">
                  <div class="row-actions">
                    <button class="btn-kbm-outline btn-kbm-sm" (click)="openEditProvider(p)">Edit</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="kbm-table-footer">
          <span>{{providers.length}} providers total</span>
        </div>
      </div>
    </ng-container>

    <!-- ══════════════════════════════════════════════
         TAB: CATEGORIES & TYPES
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'categories'">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:20px">

        <!-- Categories -->
        <div class="kbm-dark-table-card">
          <div class="dark-header">
            <span class="dh-title">Categories</span>
            <span class="dh-badge">{{CATEGORIES.length}} total</span>
          </div>
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <thead>
              <tr style="border-bottom:1px solid #f3f4f6">
                <th style="padding:8px 16px;text-align:left;font-size:11px;color:#9ca3af;font-weight:600">Name</th>
                <th style="padding:8px 16px;text-align:left;font-size:11px;color:#9ca3af;font-weight:600">Activities</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of CATEGORIES" class="tr-hover">
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="c.cssClass">{{c.name}}</span>
                </td>
                <td class="td-kbm" style="color:#6b7280">
                  {{activities | activityCountByCat:c.value}}
                  <span *ngIf="!(activities | activityCountByCat:c.value)">0</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Activity Types -->
        <div class="kbm-dark-table-card">
          <div class="dark-header">
            <span class="dh-title">Activity Types</span>
            <span class="dh-badge">{{ACTIVITY_TYPES.length}} types</span>
          </div>
          <table style="width:100%;border-collapse:collapse;font-size:13px">
            <thead>
              <tr style="border-bottom:1px solid #f3f4f6">
                <th style="padding:8px 16px;text-align:left;font-size:11px;color:#9ca3af;font-weight:600">Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of ACTIVITY_TYPES" class="tr-hover">
                <td class="td-kbm" style="color:#374151">{{t.name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- ══════════════════════════════════════════════
         TAB: REPORTS
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'reports'">

      <!-- Filter + Group Bar -->
      <div class="kbm-filter-bar" style="margin-bottom:20px">
        <div class="filter-row">
          <span class="date-label">Date Range:</span>
          <input type="date" [(ngModel)]="reportDateFrom" class="kbm-input" style="width:auto"/>
          <span style="color:#d1d5db">—</span>
          <input type="date" [(ngModel)]="reportDateTo" class="kbm-input" style="width:auto"/>
          <div style="width:1px;height:16px;background:#e5e7eb;margin:0 4px"></div>
          <span class="date-label">Group By:</span>
          <div style="display:flex;gap:4px">
            <button *ngFor="let g of [['activity','Activity'],['category','Category'],['property','Property'],['provider','Provider']]"
              class="btn-kbm-sm" [class.btn-kbm-primary]="reportGroupBy === g[0]" [class.btn-kbm-outline]="reportGroupBy !== g[0]"
              (click)="reportGroupBy = g[0]">{{g[1]}}</button>
          </div>
          <div style="margin-left:auto;display:flex;gap:4px">
            <button *ngFor="let v of [['overview','Overview'],['breakdown','Breakdown'],['commission','Commission']]"
              class="btn-kbm-sm" [class.btn-kbm-primary]="reportView === v[0]" [class.btn-kbm-outline]="reportView !== v[0]"
              (click)="reportView = v[0]">{{v[1]}}</button>
          </div>
        </div>
      </div>

      <!-- KPI Row 1 -->
      <div class="kbm-kpi-grid">
        <div class="kpi-card">
          <div class="kpi-label">Activities Sold</div>
          <div class="kpi-value">{{reportTotalActsSold}}</div>
          <div class="kpi-sub">{{reportInRange.length}} reservation{{reportInRange.length !== 1 ? 's' : ''}}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Gross Revenue</div>
          <div class="kpi-value">{{fmt$(reportTotalRevenue)}}</div>
          <div class="kpi-sub">{{fmt$(reportAvgPerRes | roundNum)}} avg / reservation</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Amount Collected</div>
          <div class="kpi-value">{{fmt$(reportTotalCollected)}}</div>
          <div class="kpi-sub">{{reportCollRate}}% collection rate</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Est. Commission</div>
          <div class="kpi-value">{{fmt$(reportTotalComm | roundNum)}}</div>
          <div class="kpi-sub">10% of gross revenue</div>
        </div>
      </div>

      <!-- KPI Row 2 -->
      <div class="kbm-kpi-grid">
        <div class="kpi-card">
          <div class="kpi-label">Total Guests</div>
          <div class="kpi-value">{{reportTotalGuests}}</div>
          <div class="kpi-sub">{{reportInRange.length}} reservation{{reportInRange.length !== 1 ? 's' : ''}}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Balance Outstanding</div>
          <div class="kpi-value">{{fmt$(reportTotalBalance | roundNum)}}</div>
          <div class="kpi-sub" [class.danger]="reportTotalBalance > 0">
            {{reportTotalBalance > 0 ? 'Needs follow-up' : 'Fully collected'}}
          </div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Paid in Full</div>
          <div class="kpi-value">{{reportInRange | paidCount}}</div>
          <div class="kpi-sub">of {{reportInRange.length}} reservations</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">Top Activity</div>
          <div class="kpi-value" style="font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
            {{(reportByActivity)[0]?.name || '—'}}
          </div>
          <div class="kpi-sub">
            {{(reportByActivity)[0] ? fmt$((reportByActivity)[0]?.revenue | roundNum) : 'No data'}}
          </div>
        </div>
      </div>

      <!-- Charts + Overview -->
      <ng-container *ngIf="reportView === 'overview' || reportView === 'breakdown'">

        <div class="kbm-chart-grid">

          <!-- Monthly revenue chart -->
          <div class="chart-card">
            <div class="chart-title">Revenue by Month</div>
            <ng-container *ngIf="reportMonthlyTrend.length === 0">
              <div style="display:flex;align-items:center;justify-content:center;height:140px;font-size:13px;color:#9ca3af">No data in range</div>
            </ng-container>
            <div *ngIf="reportMonthlyTrend.length > 0" class="month-bar-chart">
              <div class="bars-row">
                <div *ngFor="let mo of reportMonthlyTrend" class="month-col">
                  <div class="bar" [style.height]="barHeight(mo.revenue, (reportMonthlyTrend | maxVal:'revenue'))"></div>
                </div>
              </div>
              <div class="labels-row">
                <div *ngFor="let mo of reportMonthlyTrend" class="month-col">
                  <div class="mo-name">{{mo.label}}</div>
                  <div class="mo-rev">{{fmt$(mo.revenue)}}</div>
                  <div class="mo-coll">{{fmt$(mo.collected)}}</div>
                  <div class="mo-comm">{{fmt$(mo.comm)}}</div>
                </div>
              </div>
              <div class="chart-legend">
                <div class="leg-item"><span class="leg-dot" style="background:#10b981"></span>Billed</div>
                <div class="leg-item"><span class="leg-dot" style="background:#3b82f6"></span>Collected</div>
                <div class="leg-item"><span class="leg-dot" style="background:#f59e0b"></span>Commission</div>
              </div>
            </div>
          </div>

          <!-- Payment status chart -->
          <div class="chart-card">
            <div class="chart-title">Payment Status Distribution</div>
            <ng-container *ngIf="reportPayBreakdown.length === 0">
              <div style="display:flex;align-items:center;justify-content:center;height:140px;font-size:13px;color:#9ca3af">No data in range</div>
            </ng-container>
            <ng-container *ngIf="reportPayBreakdown.length > 0">
              <div *ngFor="let pb of reportPayBreakdown" style="margin-bottom:12px">
                <div style="display:flex;justify-content:space-between;font-size:11px;margin-bottom:6px">
                  <span style="font-weight:600;color:#4b5563;display:flex;align-items:center;gap:6px">
                    <span style="width:8px;height:8px;border-radius:50%;display:inline-block" [style.background]="pb.color"></span>
                    {{pb.name}}
                  </span>
                  <span style="color:#9ca3af">{{pb.value}} res · {{reportInRange.length ? (pb.value / reportInRange.length * 100 | number:'1.0-0') : 0}}%</span>
                </div>
                <div style="height:8px;background:#f3f4f6;border-radius:20px;overflow:hidden">
                  <div style="height:100%;border-radius:20px" [style.width]="reportInRange.length ? (pb.value / reportInRange.length * 100) + '%' : '0'" [style.background]="pb.color"></div>
                </div>
              </div>
              <div style="margin-top:20px;padding-top:16px;border-top:1px solid #f3f4f6;display:grid;grid-template-columns:1fr 1fr;gap:12px">
                <div><div style="font-size:11px;color:#9ca3af;margin-bottom:2px">Total Billed</div><div style="font-weight:700;font-size:13px">{{fmt$(reportTotalRevenue)}}</div></div>
                <div><div style="font-size:11px;color:#9ca3af;margin-bottom:2px">Collected</div><div style="font-weight:700;font-size:13px;color:#059669">{{fmt$(reportTotalCollected)}}</div></div>
                <div><div style="font-size:11px;color:#9ca3af;margin-bottom:2px">Outstanding</div><div style="font-weight:700;font-size:13px" [style.color]="reportTotalBalance > 0 ? '#dc2626' : '#1f2937'">{{fmt$(reportTotalBalance | roundNum)}}</div></div>
                <div><div style="font-size:11px;color:#9ca3af;margin-bottom:2px">Collection Rate</div><div style="font-weight:700;font-size:13px">{{reportCollRate}}%</div></div>
              </div>
            </ng-container>
          </div>

          <!-- Revenue by group -->
          <div class="chart-card">
            <div class="chart-title">Revenue by {{reportGroupLabel}}</div>
            <div *ngIf="reportActiveTable.length === 0" style="display:flex;align-items:center;justify-content:center;height:120px;font-size:13px;color:#9ca3af">No data in range</div>
            <div class="css-bar-chart" *ngIf="reportActiveTable.length > 0">
              <div *ngFor="let row of reportActiveTable | slice:0:8; let i = index" class="bar-row">
                <div class="bar-label" [title]="row.emoji ? (row.emoji + ' ' + row.name) : row.name">
                  {{row.emoji ? (row.emoji + ' ') : ''}}{{row.name}}
                </div>
                <div class="bar-track">
                  <div class="bar-fill" [style.width]="barWidth(row.revenue, reportActiveTable, 'revenue')" [style.background]="BAR_COLORS[i % BAR_COLORS.length]"></div>
                </div>
                <div class="bar-value">{{fmt$(row.revenue | roundNum)}}</div>
              </div>
            </div>
          </div>

          <!-- Bookings by group -->
          <div class="chart-card">
            <div class="chart-title">Bookings by {{reportGroupLabel}}</div>
            <div *ngIf="reportActiveTable.length === 0" style="display:flex;align-items:center;justify-content:center;height:120px;font-size:13px;color:#9ca3af">No data in range</div>
            <div class="css-bar-chart" *ngIf="reportActiveTable.length > 0">
              <div *ngFor="let row of reportActiveTable | slice:0:8" class="bar-row">
                <div class="bar-label" [title]="row.name">{{row.emoji ? (row.emoji + ' ') : ''}}{{row.name}}</div>
                <div class="bar-track">
                  <div class="bar-fill" [style.width]="barWidth(row.count, reportActiveTable, 'count')" style="background:#10b981"></div>
                </div>
                <div class="bar-value">{{row.count}} booked</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Breakdown table -->
        <div class="kbm-dark-table-card">
          <div class="dark-header">
            <span class="dh-title">Detailed Breakdown — by {{reportGroupLabel}}</span>
            <span class="dh-meta">{{reportInRange.length}} reservations · {{reportDateFrom}} to {{reportDateTo}}</span>
          </div>
          <div style="overflow-x:auto">
            <table style="width:100%;border-collapse:collapse;font-size:13px;min-width:680px">
              <thead>
                <tr style="border-bottom:1px solid #f3f4f6;background:#f9fafb">
                  <th *ngIf="reportGroupBy === 'activity'" class="th-light">Activity</th>
                  <th *ngIf="reportGroupBy === 'activity'" class="th-light">Category</th>
                  <th *ngIf="reportGroupBy === 'category'" class="th-light">Category</th>
                  <th *ngIf="reportGroupBy === 'property' || reportGroupBy === 'provider'" class="th-light">Name</th>
                  <th class="th-light">Bookings</th>
                  <th class="th-light">Guests</th>
                  <th class="th-light">Gross Revenue</th>
                  <th class="th-light">Commission (10%)</th>
                  <th class="th-light">Avg / Booking</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="reportActiveTable.length === 0">
                  <td colspan="7" style="text-align:center;padding:40px 16px;color:#9ca3af">No data in selected date range.</td>
                </tr>
                <tr *ngFor="let row of reportActiveTable" class="tr-hover">
                  <td *ngIf="reportGroupBy === 'activity'" class="td-kbm">
                    <div style="display:flex;align-items:center;gap:8px">
                      <span style="font-size:16px">{{row.emoji}}</span>
                      <span style="font-weight:600;color:#1f2937">{{row.name}}</span>
                    </div>
                  </td>
                  <td *ngIf="reportGroupBy === 'activity'" class="td-kbm">
                    <span class="badge-kbm" [ngClass]="getCategoryInfo(row.cat).cssClass">{{getCategoryInfo(row.cat).label}}</span>
                  </td>
                  <td *ngIf="reportGroupBy === 'category'" class="td-kbm">
                    <span class="badge-kbm" [ngClass]="getCategoryInfo(row.cat).cssClass">{{getCategoryInfo(row.cat).label}}</span>
                  </td>
                  <td *ngIf="reportGroupBy === 'property' || reportGroupBy === 'provider'" class="td-kbm" style="font-weight:600;color:#1f2937">{{row.name}}</td>
                  <td class="td-kbm" style="text-align:center;font-weight:500;color:#374151">{{row.count}}</td>
                  <td class="td-kbm" style="text-align:center;color:#4b5563">{{row.guests}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#1f2937">{{fmt$(row.revenue | roundNum)}}</td>
                  <td class="td-kbm" style="font-weight:600;color:#b45309">{{fmt$(row.comm | roundNum)}}</td>
                  <td class="td-kbm" style="color:#4b5563">{{row.count > 0 ? fmt$(row.revenue / row.count | roundNum) : '—'}}</td>
                </tr>
              </tbody>
              <tfoot *ngIf="reportActiveTable.length > 0">
                <tr style="background:#f9fafb;border-top:2px solid #e5e7eb">
                  <td class="td-kbm" [attr.colspan]="reportGroupBy === 'activity' ? 2 : 1" style="font-weight:700;color:#1f2937">Totals</td>
                  <td class="td-kbm" style="text-align:center;font-weight:700">{{reportActiveTable | sumProp:'count'}}</td>
                  <td class="td-kbm" style="text-align:center;font-weight:700">{{reportActiveTable | sumProp:'guests'}}</td>
                  <td class="td-kbm" style="font-weight:700">{{fmt$(reportActiveTable | sumProp:'revenue' | roundNum)}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#b45309">{{fmt$(reportActiveTable | sumProp:'comm' | roundNum)}}</td>
                  <td class="td-kbm"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <!-- Individual reservations (breakdown view only) -->
        <div *ngIf="reportView === 'breakdown'" class="kbm-dark-table-card">
          <div class="dark-header">
            <span class="dh-title">Individual Reservations in Range</span>
          </div>
          <div style="overflow-x:auto">
            <table style="width:100%;border-collapse:collapse;font-size:13px;min-width:820px">
              <thead>
                <tr style="border-bottom:1px solid #f3f4f6;background:#f9fafb">
                  <th *ngFor="let h of ['Res #','Guest','Property','Activities','Activity Date','Guests','Amount Due','Paid','Balance','Pay Status','Book Status']" class="th-light">{{h}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="reportInRange.length === 0">
                  <td colspan="11" style="text-align:center;padding:32px 16px;color:#9ca3af">No reservations in selected range.</td>
                </tr>
                <tr *ngFor="let r of reportInRange" class="tr-hover">
                  <td class="td-kbm" style="font-family:monospace;font-size:11px;font-weight:700;color:#059669">{{r.reservationNumber}}</td>
                  <td class="td-kbm" style="font-weight:500;color:#1f2937">{{r.firstName}} {{r.lastName}}</td>
                  <td class="td-kbm" style="font-size:11px;color:#6b7280">{{r.property}} · {{r.unit}}</td>
                  <td class="td-kbm" style="font-size:11px;color:#4b5563">{{activityNames(r.activityIds) | truncate:30}}</td>
                  <td class="td-kbm" style="font-size:11px;color:#4b5563;white-space:nowrap">{{fmtDate(r.activityDate)}}</td>
                  <td class="td-kbm" style="text-align:center;color:#4b5563">{{r.numGuests}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#1f2937">{{fmt$(r.amountDue || 0)}}</td>
                  <td class="td-kbm" style="font-weight:600;color:#059669">{{fmt$(r.amountPaid || 0)}}</td>
                  <td class="td-kbm">
                    <span [style.color]="(r.amountDue - r.amountPaid) > 0 ? '#dc2626' : '#9ca3af'" style="font-weight:600">
                      {{fmt$((r.amountDue || 0) - (r.amountPaid || 0))}}
                    </span>
                  </td>
                  <td class="td-kbm"><span class="badge-kbm" [ngClass]="'badge-' + r.paymentStatus">{{r.paymentStatus | titlecase}}</span></td>
                  <td class="td-kbm"><span class="badge-kbm" [ngClass]="'badge-' + r.bookingStatus">{{r.bookingStatus | titlecase}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="kbm-table-footer"><span>{{reportInRange.length}} reservation{{reportInRange.length !== 1 ? 's' : ''}} in range</span></div>
        </div>
      </ng-container>

      <!-- ── COMMISSION VIEW ── -->
      <ng-container *ngIf="reportView === 'commission'">
        <div class="chart-card" style="background:#fff;border:1px solid #f3f4f6;border-radius:12px;padding:20px;margin-bottom:20px">
          <div class="chart-title">Commission by Provider</div>
          <div class="css-bar-chart">
            <div *ngFor="let p of reportByProvider | slice:0:8" class="bar-row">
              <div class="bar-label" [title]="p.name">{{p.name}}</div>
              <div class="bar-track">
                <div class="bar-fill" [style.width]="barWidth(p.comm, reportByProvider, 'comm')" style="background:#f59e0b"></div>
              </div>
              <div class="bar-value">{{fmt$(p.comm | roundNum)}}</div>
            </div>
          </div>
        </div>
        <div class="kbm-dark-table-card">
          <div class="dark-header">
            <span class="dh-title">Commission Report — by Provider</span>
            <span class="dh-badge">10% default rate applied</span>
          </div>
          <div style="overflow-x:auto">
            <table style="width:100%;border-collapse:collapse;font-size:13px">
              <thead>
                <tr style="border-bottom:1px solid #f3f4f6;background:#f9fafb">
                  <th *ngFor="let h of ['Provider','Bookings','Gross Revenue','Commission (10%)','Avg Comm / Booking']" class="th-light">{{h}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="reportByProvider.length === 0">
                  <td colspan="5" style="text-align:center;padding:32px 16px;color:#9ca3af">No data in selected range.</td>
                </tr>
                <tr *ngFor="let p of reportByProvider" class="tr-hover">
                  <td class="td-kbm" style="font-weight:600;color:#1f2937">{{p.name}}</td>
                  <td class="td-kbm" style="text-align:center;font-weight:500;color:#374151">{{p.count}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#1f2937">{{fmt$(p.revenue | roundNum)}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#b45309">{{fmt$(p.comm | roundNum)}}</td>
                  <td class="td-kbm" style="color:#4b5563">{{p.count > 0 ? fmt$(p.comm / p.count | roundNum) : '—'}}</td>
                </tr>
              </tbody>
              <tfoot *ngIf="reportByProvider.length > 0">
                <tr style="background:#f9fafb;border-top:2px solid #e5e7eb">
                  <td class="td-kbm" style="font-weight:700;color:#1f2937">Totals</td>
                  <td class="td-kbm" style="text-align:center;font-weight:700">{{reportByProvider | sumProp:'count'}}</td>
                  <td class="td-kbm" style="font-weight:700">{{fmt$(reportByProvider | sumProp:'revenue' | roundNum)}}</td>
                  <td class="td-kbm" style="font-weight:700;color:#b45309">{{fmt$(reportByProvider | sumProp:'comm' | roundNum)}}</td>
                  <td class="td-kbm"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </ng-container>

    </ng-container>
    <!-- end reports tab -->

    <!-- ══════════════════════════════════════════════
         TAB: WISH LISTS
    ══════════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'wishlists'">

      <!-- Toolbar -->
      <div class="kbm-filter-bar" style="margin-bottom:16px">
        <div class="filter-row">
          <span style="font-size:13px;font-weight:600;color:#4b5563">Status:</span>
          <button *ngFor="let s of WISHLIST_STATUSES" class="btn-kbm-sm"
            [class.btn-kbm-primary]="wishlistStatusFilter === s.value"
            [class.btn-kbm-outline]="wishlistStatusFilter !== s.value"
            (click)="wishlistStatusFilter = s.value">
            {{s.label}}
          </button>
          <div style="margin-left:auto">
            <button class="btn-kbm-primary" (click)="openCreateWishlist()">+ New Wish List</button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="kbm-table-card">
        <div style="overflow-x:auto">
          <table style="width:100%;border-collapse:collapse;font-size:13px;min-width:900px">
            <thead>
              <tr style="background:#111827">
                <th class="th-kbm">Guest</th>
                <th class="th-kbm">Email</th>
                <th class="th-kbm">Island</th>
                <th class="th-kbm">Check In</th>
                <th class="th-kbm" style="text-align:center">Items</th>
                <th class="th-kbm">Status</th>
                <th class="th-kbm">Created</th>
                <th class="th-kbm">Sent</th>
                <th class="th-kbm">Viewed</th>
                <th class="th-kbm" style="width:120px"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="wishlistsLoading">
                <td colspan="10" style="text-align:center;padding:48px 16px;color:#9ca3af">
                  <i class="pi pi-spin pi-spinner" style="margin-right:8px"></i>Loading…
                </td>
              </tr>
              <tr *ngIf="!wishlistsLoading && filteredWishlists.length === 0">
                <td colspan="10" style="text-align:center;padding:48px 16px;color:#9ca3af">No wish lists found.</td>
              </tr>
              <tr *ngFor="let wl of filteredWishlists" class="tr-hover" style="cursor:pointer" (click)="onWishlistRowClick(wl)">
                <td class="td-kbm" style="font-weight:600;color:#1f2937">{{wl.guestFirstName}} {{wl.guestLastName}}</td>
                <td class="td-kbm" style="font-size:12px;color:#6b7280">{{wl.guestEmail || '—'}}</td>
                <td class="td-kbm" style="font-size:12px;color:#6b7280">{{wl.addressIsland || '—'}}</td>
                <td class="td-kbm" style="font-size:12px;color:#4b5563;white-space:nowrap">{{fmtDate(wl.checkIn)}}</td>
                <td class="td-kbm" style="text-align:center;font-weight:600;color:#374151">{{wl.items?.length || 0}}</td>
                <td class="td-kbm">
                  <span class="badge-kbm" [ngClass]="wishlistStatusBadgeClass(wl.status)">{{wl.status | titlecase}}</span>
                </td>
                <td class="td-kbm" style="font-size:12px;color:#9ca3af;white-space:nowrap">{{fmtDate(wl.createDate)}}</td>
                <td class="td-kbm" style="font-size:12px;color:#9ca3af;white-space:nowrap">{{wl.sentDate ? fmtDate(wl.sentDate) : '—'}}</td>
                <td class="td-kbm" style="font-size:12px;color:#9ca3af;white-space:nowrap">{{wl.viewedDate ? fmtDate(wl.viewedDate) : '—'}}</td>
                <td class="td-kbm" (click)="$event.stopPropagation()">
                  <div class="row-actions">
                    <button class="btn-kbm-outline btn-kbm-sm" (click)="onWishlistRowClick(wl)">View</button>
                    <button class="btn-kbm-outline btn-kbm-sm" (click)="sendToGuest(wl)" [disabled]="wishlistSending" title="Send to guest">Send</button>
                    <button class="btn-kbm-outline btn-kbm-sm" style="color:#dc2626;border-color:#fecaca" (click)="deleteWishlist(wl)">Del</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="kbm-table-footer">
          <span>{{filteredWishlists.length}} of {{wishlists.length}} wish lists shown</span>
        </div>
      </div>

      <!-- ── DETAIL DIALOG ── -->
      <div *ngIf="showWishlistDetail && selectedWishlist" class="kbm-overlay" (click)="closeWishlistDetail()">
        <div class="kbm-dialog" (click)="$event.stopPropagation()">

          <div class="kbm-dialog-header">
            <span class="kbm-dialog-title">Wish List — {{selectedWishlist.guestFirstName}} {{selectedWishlist.guestLastName}}</span>
            <button class="kbm-dialog-close" (click)="closeWishlistDetail()">&times;</button>
          </div>

          <div class="kbm-dialog-body">

            <!-- Section: Guest Info -->
            <div class="wl-section-label">Guest Information</div>
            <div class="wl-form-grid">
              <div class="wl-field">
                <label>First Name</label>
                <input class="kbm-input" [(ngModel)]="selectedWishlist.guestFirstName"/>
              </div>
              <div class="wl-field">
                <label>Last Name</label>
                <input class="kbm-input" [(ngModel)]="selectedWishlist.guestLastName"/>
              </div>
              <div class="wl-field">
                <label>Email</label>
                <input class="kbm-input" type="email" [(ngModel)]="selectedWishlist.guestEmail"/>
              </div>
              <div class="wl-field">
                <label>Phone</label>
                <input class="kbm-input" [(ngModel)]="selectedWishlist.guestPhone"/>
              </div>
              <div class="wl-field">
                <label>Reservation ID</label>
                <input class="kbm-input" type="number" [(ngModel)]="selectedWishlist.reservationId"/>
              </div>
              <div class="wl-field">
                <label>Property</label>
                <input class="kbm-input" [(ngModel)]="selectedWishlist.propertyName"/>
              </div>
              <div class="wl-field">
                <label>Check In</label>
                <input class="kbm-input" type="date" [(ngModel)]="selectedWishlist.checkIn"/>
              </div>
              <div class="wl-field">
                <label>Check Out</label>
                <input class="kbm-input" type="date" [(ngModel)]="selectedWishlist.checkOut"/>
              </div>
              <div class="wl-field">
                <label>Island</label>
                <input class="kbm-input" [(ngModel)]="selectedWishlist.addressIsland"/>
              </div>
              <div class="wl-field">
                <label>Status</label>
                <select class="kbm-input" [(ngModel)]="selectedWishlist.status">
                  <option *ngFor="let s of WISHLIST_STATUSES.slice(1)" [value]="s.value">{{s.label}}</option>
                </select>
              </div>
            </div>

            <!-- Section: Staff Notes -->
            <div class="wl-section-label" style="margin-top:20px">Staff Notes</div>
            <textarea class="kbm-input" rows="3" style="width:100%;resize:vertical"
              [(ngModel)]="selectedWishlist.staffNotes"
              placeholder="Internal notes (not visible to guest)"></textarea>

            <!-- Section: Items -->
            <div class="wl-section-label" style="margin-top:20px">
              Wish List Items ({{selectedWishlist.items?.length || 0}})
            </div>

            <div *ngIf="!selectedWishlist.items?.length" style="padding:16px;text-align:center;color:#9ca3af;font-size:13px">
              No items on this wish list yet.
            </div>

            <div *ngFor="let item of selectedWishlist.items; let i = index" class="wl-item-card">
              <div class="wl-item-header">
                <span style="font-weight:600;color:#1f2937;font-size:13px">{{item.activityName}}</span>
                <span class="badge-kbm" [ngClass]="getCategoryInfo(item.category).cssClass" style="margin-left:8px">
                  {{getCategoryInfo(item.category).label}}
                </span>
                <button class="btn-kbm-sm" style="margin-left:auto;color:#dc2626;border:1px solid #fecaca;background:#fff"
                  (click)="removeSelectedWishlistItem(i)">Remove</button>
              </div>
              <div class="wl-form-grid" style="margin-top:10px">
                <div class="wl-field">
                  <label>Preferred Date</label>
                  <input class="kbm-input" type="date" [(ngModel)]="item.preferredDate"/>
                </div>
                <div class="wl-field">
                  <label>Preferred Time</label>
                  <input class="kbm-input" [(ngModel)]="item.preferredTime" placeholder="e.g. 08:00"/>
                </div>
                <div class="wl-field">
                  <label>Adults</label>
                  <input class="kbm-input" type="number" min="0" [(ngModel)]="item.adultCount"/>
                </div>
                <div class="wl-field">
                  <label>Youth</label>
                  <input class="kbm-input" type="number" min="0" [(ngModel)]="item.youthCount"/>
                </div>
                <div class="wl-field">
                  <label>Infants</label>
                  <input class="kbm-input" type="number" min="0" [(ngModel)]="item.infantCount"/>
                </div>
              </div>
              <div style="margin-top:8px">
                <label style="font-size:11px;color:#9ca3af;display:block;margin-bottom:4px">Staff Note for this item</label>
                <input class="kbm-input" style="width:100%" [(ngModel)]="item.staffNote" placeholder="Internal note for this activity"/>
              </div>
            </div>

            <!-- Add activity to detail -->
            <div style="margin-top:16px">
              <div style="font-size:12px;color:#6b7280;margin-bottom:8px">Add activity to this wish list:</div>
              <div style="display:flex;gap:8px;align-items:center">
                <input class="kbm-input" style="flex:1" [(ngModel)]="wishlistActivitySearch" placeholder="Search active activities…"/>
              </div>
              <div *ngIf="wishlistActivitySearch" class="wl-activity-picker">
                <div *ngFor="let a of newWishlistFilteredActivities" class="wl-picker-row"
                  (click)="addActivityToSelectedWishlist(a); wishlistActivitySearch = ''">
                  <span style="font-size:16px">{{a.emoji}}</span>
                  <span style="font-size:13px;color:#1f2937;font-weight:500">{{a.name}}</span>
                  <span class="badge-kbm" [ngClass]="getCategoryInfo(a.category).cssClass" style="margin-left:auto">
                    {{getCategoryInfo(a.category).label}}
                  </span>
                </div>
                <div *ngIf="!newWishlistFilteredActivities.length" style="padding:12px;color:#9ca3af;font-size:13px">No matching activities.</div>
              </div>
            </div>

          </div><!-- /dialog-body -->

          <div class="kbm-dialog-footer">
            <button class="btn-kbm-outline" (click)="closeWishlistDetail()">Close</button>
            <button class="btn-kbm-outline" style="color:#dc2626;border-color:#fecaca"
              (click)="deleteWishlist(selectedWishlist)">Delete</button>
            <button class="btn-kbm-outline"
              (click)="sendToGuest(selectedWishlist)"
              [disabled]="wishlistSending || !selectedWishlist.wishlistId">
              <ng-container *ngIf="wishlistSending; else sendLabel">
                <i class="pi pi-spin pi-spinner" style="font-size:11px;margin-right:4px"></i>Sending…
              </ng-container>
              <ng-template #sendLabel>Send to Guest</ng-template>
            </button>
            <button class="btn-kbm-primary"
              (click)="saveWishlistChanges()"
              [disabled]="wishlistSaving">
              <ng-container *ngIf="wishlistSaving; else saveLabel">
                <i class="pi pi-spin pi-spinner" style="font-size:11px;margin-right:4px"></i>Saving…
              </ng-container>
              <ng-template #saveLabel>Save Changes</ng-template>
            </button>
          </div>

        </div><!-- /kbm-dialog -->
      </div><!-- /overlay -->

      <!-- ── CREATE DIALOG ── -->
      <div *ngIf="showCreateWishlist" class="kbm-overlay" (click)="closeCreateWishlist()">
        <div class="kbm-dialog" (click)="$event.stopPropagation()">

          <div class="kbm-dialog-header">
            <span class="kbm-dialog-title">New Wish List (Staff-Suggested)</span>
            <button class="kbm-dialog-close" (click)="closeCreateWishlist()">&times;</button>
          </div>

          <div class="kbm-dialog-body">

            <!-- Guest Info -->
            <div class="wl-section-label">Guest Information</div>
            <div class="wl-form-grid">
              <div class="wl-field">
                <label>First Name</label>
                <input class="kbm-input" [(ngModel)]="newWishlist.guestFirstName"/>
              </div>
              <div class="wl-field">
                <label>Last Name</label>
                <input class="kbm-input" [(ngModel)]="newWishlist.guestLastName"/>
              </div>
              <div class="wl-field">
                <label>Email</label>
                <input class="kbm-input" type="email" [(ngModel)]="newWishlist.guestEmail"/>
              </div>
              <div class="wl-field">
                <label>Phone</label>
                <input class="kbm-input" [(ngModel)]="newWishlist.guestPhone"/>
              </div>
              <div class="wl-field">
                <label>Reservation ID</label>
                <input class="kbm-input" type="number" [(ngModel)]="newWishlist.reservationId"/>
              </div>
              <div class="wl-field">
                <label>Property</label>
                <input class="kbm-input" [(ngModel)]="newWishlist.propertyName"/>
              </div>
              <div class="wl-field">
                <label>Check In</label>
                <input class="kbm-input" type="date" [(ngModel)]="newWishlist.checkIn"/>
              </div>
              <div class="wl-field">
                <label>Check Out</label>
                <input class="kbm-input" type="date" [(ngModel)]="newWishlist.checkOut"/>
              </div>
              <div class="wl-field">
                <label>Island</label>
                <input class="kbm-input" [(ngModel)]="newWishlist.addressIsland"/>
              </div>
            </div>

            <!-- Activity Picker -->
            <div class="wl-section-label" style="margin-top:20px">Add Activities</div>
            <div style="display:flex;gap:8px;align-items:center;margin-bottom:8px">
              <input class="kbm-input" style="flex:1" [(ngModel)]="wishlistActivitySearch" placeholder="Search active activities…"/>
            </div>
            <div *ngIf="wishlistActivitySearch" class="wl-activity-picker">
              <div *ngFor="let a of newWishlistFilteredActivities" class="wl-picker-row" (click)="addActivityToNewWishlist(a)">
                <span style="font-size:16px">{{a.emoji}}</span>
                <span style="font-size:13px;color:#1f2937;font-weight:500">{{a.name}}</span>
                <span class="badge-kbm" [ngClass]="getCategoryInfo(a.category).cssClass" style="margin-left:auto">
                  {{getCategoryInfo(a.category).label}}
                </span>
              </div>
              <div *ngIf="!newWishlistFilteredActivities.length" style="padding:12px;color:#9ca3af;font-size:13px">No matching activities.</div>
            </div>

            <!-- Items -->
            <div *ngIf="newWishlist.items?.length" style="margin-top:12px">
              <div *ngFor="let item of newWishlist.items; let i = index" class="wl-item-card">
                <div class="wl-item-header">
                  <span style="font-weight:600;color:#1f2937;font-size:13px">{{item.activityName}}</span>
                  <span class="badge-kbm" [ngClass]="getCategoryInfo(item.category).cssClass" style="margin-left:8px">
                    {{getCategoryInfo(item.category).label}}
                  </span>
                  <button class="btn-kbm-sm" style="margin-left:auto;color:#dc2626;border:1px solid #fecaca;background:#fff"
                    (click)="removeNewWishlistItem(i)">Remove</button>
                </div>
                <div class="wl-form-grid" style="margin-top:10px">
                  <div class="wl-field">
                    <label>Preferred Date</label>
                    <input class="kbm-input" type="date" [(ngModel)]="item.preferredDate"/>
                  </div>
                  <div class="wl-field">
                    <label>Preferred Time</label>
                    <input class="kbm-input" [(ngModel)]="item.preferredTime" placeholder="e.g. 08:00"/>
                  </div>
                  <div class="wl-field">
                    <label>Adults</label>
                    <input class="kbm-input" type="number" min="0" [(ngModel)]="item.adultCount"/>
                  </div>
                  <div class="wl-field">
                    <label>Youth</label>
                    <input class="kbm-input" type="number" min="0" [(ngModel)]="item.youthCount"/>
                  </div>
                  <div class="wl-field">
                    <label>Infants</label>
                    <input class="kbm-input" type="number" min="0" [(ngModel)]="item.infantCount"/>
                  </div>
                </div>
              </div>
            </div>

            <!-- Staff Notes -->
            <div class="wl-section-label" style="margin-top:20px">Staff Notes</div>
            <textarea class="kbm-input" rows="2" style="width:100%;resize:vertical"
              [(ngModel)]="newWishlist.staffNotes"
              placeholder="Internal notes"></textarea>

          </div><!-- /dialog-body -->

          <div class="kbm-dialog-footer">
            <button class="btn-kbm-outline" (click)="closeCreateWishlist()">Cancel</button>
            <button class="btn-kbm-outline"
              (click)="saveNewWishlist(true)"
              [disabled]="wishlistSaving">Save &amp; Send to Guest</button>
            <button class="btn-kbm-primary"
              (click)="saveNewWishlist(false)"
              [disabled]="wishlistSaving">
              <ng-container *ngIf="wishlistSaving; else createLabel">
                <i class="pi pi-spin pi-spinner" style="font-size:11px;margin-right:4px"></i>Saving…
              </ng-container>
              <ng-template #createLabel>Save</ng-template>
            </button>
          </div>

        </div><!-- /kbm-dialog -->
      </div><!-- /overlay -->

    </ng-container>
    <!-- end wishlists tab -->

  </div><!-- /kbm-body -->

  <!-- Toast -->
  <div class="kbm-toast" [class.show]="toastVisible">
    <span class="toast-dot"></span>{{toastMsg}}
  </div>

</div>
